module.exports = __webpack_public_path__ + "static/media/Upsell_Tab_Popular@3x.b391005e.png";